/**
 * @description 累充奖励
 */
import { RewardTypeEnum, RewardStatusEnum } from "@/types/reward";
import Image from "next/image";
import { RewardIcon } from "./reward-icon";
import { isEmpty } from "lodash-es";
import ProgressBar from "@/features/reward/components/progress-bar";
import GiftIcon from '@/features/reward/assets/gift-recharge.png';
import { Button } from "@/components/ui/button";
import { useRouter } from "@/i18n/navigation";
import { activityPage } from "@/const/page-url";
import { useBalanceFormatter } from "@/hooks/use-balance-formatter";
import { useTranslations } from "next-intl";
import { ActivitySourceEnum } from "@/const/report";

interface CumulativeRewardProps {
  status: RewardStatusEnum;
  id: number;
  depositProgress?: {
    currentAmount: number;
    targetAmount: number;
  };
  currency: string;
  onSpin?: () => any;
}

export const CumulativeReward = (props: CumulativeRewardProps) => {
  const { id, status, depositProgress, currency, onSpin } = props;
  const showProgress = status === RewardStatusEnum.DEPOSIT;
  const progressPercent = showProgress && !isEmpty(depositProgress) ?
    (depositProgress.currentAmount / depositProgress.targetAmount) * 100 : 0;
  const router = useRouter();
  const { formatCurrencyDetail } = useBalanceFormatter();
  const t = useTranslations('reward');

  const handleSpin = () => {
    const searchParams = new URLSearchParams();
    searchParams.set('id', id.toString());
    router.push(`${activityPage.cumulativeDeposit}?${searchParams.toString()}&trackSource=${ActivitySourceEnum.rewardsPopup}`);
    onSpin?.();
  };

  if (![RewardStatusEnum.DEPOSIT, RewardStatusEnum.SPIN].includes(status)) {
    return null;
  }

  return (
    <div className="bg-dark-special rounded-lg py-3 pr-3 flex items-center justify-between"
      style={{
        background: 'linear-gradient(to bottom right, #1D3657 0%, #1B2131 65%, #1B2131 100%)',
      }}
    >
      <RewardIcon type={RewardTypeEnum.CUMULATIVE_REWARD} className="mr-2.5" />
      <div className="flex-1">
        <div className="flex items-center">
          <div className="text-white text-xs font-medium leading-3">{t('rechargeWheel')}</div>
        </div>
        {
          showProgress && (
            <>
              <div className="flex items-center justify-between mt-3">
                <div className="text-tertiary text-[11px] font-medium leading-3">
                  {t('recharge')} {`${formatCurrencyDetail((depositProgress?.currentAmount || 0))} / ${formatCurrencyDetail((depositProgress?.targetAmount || 0)) + ' ' + currency}`}
                </div>
                <Image src={GiftIcon.src} alt="gift" width={12} height={12} />
              </div>
              <ProgressBar progress={progressPercent} className="mt-2 h-2" barClassName="bg-accent-blue" />
            </>
          )
        }
      </div>
      {status === RewardStatusEnum.SPIN && (
        <Button
          variant="primary"
          className="w-[90px] h-8 ml-[10px]"
          onClick={handleSpin}
        >{t('spin')}</Button>
      )}
    </div>
  );
};